import React from "react";
import { Link, useLocation } from "react-router-dom";
import { destinazioneArticolo } from "./destinazioneArticolo";

export default function LinkArticolo({ codVS, children, ...props }) {
  const location = useLocation();
  return <Link aria-label={children == null ? String(codVS) : undefined} {...props} to={destinazioneArticolo(location, codVS)} state={{ schedaArticolo: true }}>{children ?? codVS}</Link>;
}
